import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';

// Side-effect: registers v-touch. Imported per entry point (app, tripBuilder, widget iframe)
// because each bundle builds its own Vue — a component-level Vue.use() made it load-order dependent.
Vue.use(Vue2TouchEvents);
